export default function GetElementById(id, elements) {
    const found = [];

    (function recursion(elements) {
        for (const element of elements) {
            if (element.props.id === id) {
                found.push(element);
            }

            if (element.children && element.children.length > 0) {
                recursion(element.children);
            }
        }
    })(elements);

    return found.length < 2 ? found[0] : found;
}
